"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultV8Config = exports.englishDisplayDictionaryV8 = exports.defaultConfig = exports.getAllSortOptions = exports.getAllTypeaheadCategories = exports.englishDisplayDictionary = void 0;
const sanitizeTheme_1 = require("./utils/sanitizeTheme");
exports.englishDisplayDictionary = {
    'button.label': '',
    'button.icon': 'search',
    'free_text.label': 'Search for a condition, specialty or provider name',
    'free_text.placeholder': '',
    'free_text.no_suggestions': 'No suggestions',
    'free_text.empty_search_error': 'Search term is required',
    'free_text.aria_label': 'Start typing to search for a condition, specialty or provider name',
    'free_text.aria_label_with_suggestions': 'Use the up and down keys to select an appropriate suggestion for search or submit to perform a search for your entered text',
    'locale.label': 'Near',
    'locale.placeholder': 'City & State or Zip',
    // TODO remove external_link when we build add-ons
    'external_link.pre_link_text': '',
    'external_link.link_text': 'Click Here',
    'button.aria_label': 'search'
};
// These are typeahead categories meant to be exposed and managed by this widget.
//
// https://support.kyruus.com/hc/en-us/articles/360000680183-Integrating-Typeahead-with-Search
const getAllTypeaheadCategories = () => ({
    // CATEGORIES found by scraping production customer service `search_widget` configs
    // `display_text` uses defaults that we want moving forward:
    clinical_keywords: {
        label: 'Clinical Keywords',
        name: 'Clinical Keywords'
    },
    conditions_symptoms: {
        label: 'Conditions and Symptoms',
        name: 'Conditions and Symptoms'
    },
    location_name: { label: 'Location', name: 'Practice Location' },
    network_affiliation: { label: 'Affiliations', name: 'Network Affiliation' },
    practice_group: { label: 'Practices', name: 'Practice Group' },
    primary_care: { label: 'Primary Care', name: 'Primary Care' },
    provider_name: { label: 'Provider Name', name: 'Provider Name' },
    specialties: { label: 'Specialties', name: 'Specialties' },
    treatments_procedures: {
        label: 'Treatments and Procedures',
        name: 'Treatments and Procedures'
    }
    // @deprecated
    // found in customer configs but not applied
    // department: { label: 'Department' },
});
exports.getAllTypeaheadCategories = getAllTypeaheadCategories;
// Per PMC,
// "possible values are: name (alphabetical), -name (reverse-alphabetical), or a string including 'relevance' "
//
// However we're exposing:
// SORT OPTIONS found by scraping production customer service `search_widget` configs
const getAllSortOptions = () => ({
    relevance: { label: 'Relevance' },
    networks: { label: 'Networks' },
    availability_density_best: {
        label: 'Best Availability Density'
    },
    availability_soonest: {
        label: 'Soonest Availability'
    },
    name: { label: 'Name' },
    rating: { label: 'Ratings' },
    distance: { label: 'Distance' }
});
exports.getAllSortOptions = getAllSortOptions;
const defaultSortOrder = [
    'relevance',
    'availability_density_best',
    'name'
];
const defaultConfig = (theme = {}) => {
    return {
        customer_code: '',
        context_map: {},
        index: '',
        css: '',
        theme: (0, sanitizeTheme_1.sanitizeTheme)(theme),
        params: {
            allow_empty_search: false,
            focus_on_widget: true,
            persist_query: true,
            show_location: false,
            sort_order: [...defaultSortOrder],
            typeahead_categories: [
                {
                    category: 'provider_name',
                    display_text: 'Provider Name'
                },
                {
                    category: 'primary_care',
                    display_text: 'Primary Care'
                },
                {
                    category: 'clinical_keywords',
                    display_text: 'Clinical Keywords'
                },
                {
                    category: 'specialties',
                    display_text: 'Specialties'
                },
                {
                    category: 'location_name',
                    display_text: 'Location'
                }
            ],
            location_radius: 25,
            template_name: 'template1',
            open_results_in_new_tab: false,
            use_specialty_name_in_typeahead: false,
            group_suggestions_by_category: false
        },
        display_dictionary: exports.englishDisplayDictionary,
        add_ons: {}
    };
};
exports.defaultConfig = defaultConfig;
exports.englishDisplayDictionaryV8 = {
    'searchwidget.label': 'Search for a condition, specialty or provider name',
    'searchwidget.arialabel': 'Start typing to search for a condition, specialty or provider name',
    'searchwidget.arialabelwithsuggestions': 'Use the up and down keys to select an appropriate suggestion for search or submit to perform a search for your entered text',
    'searchwidget.placeholder': '',
    'searchwidget.locationlabel': 'Near',
    'searchwidget.locationplaceholder': 'City & State or Zip',
    'searchwidget.buttontext': '',
    'searchwidget.button.aria_label': 'search icon'
};
const defaultV8Config = (theme = {}) => {
    return {
        customer_code: '',
        context_map: {},
        index: '',
        css: '',
        theme: (0, sanitizeTheme_1.sanitizeTheme)(theme),
        params: {
            allow_empty_search: false,
            focus_on_widget: true,
            persist_query: true,
            show_location: false,
            sort_order: defaultSortOrder.join(','),
            typeahead_categories: [
                {
                    category: 'provider_name',
                    display_as: 'Provider Name'
                },
                {
                    category: 'primary_care',
                    display_as: 'Primary Care'
                },
                {
                    category: 'clinical_experience',
                    display_as: 'Conditions and Symptoms'
                },
                {
                    category: 'specialty_synonym',
                    display_as: 'Specialties'
                },
                {
                    category: 'practice_location',
                    display_as: 'Location'
                }
            ],
            location_search_radius: 25,
            template_name: 'template1',
            open_results_in_new_tab: false
        },
        display_dictionary: exports.englishDisplayDictionaryV8
    };
};
exports.defaultV8Config = defaultV8Config;
//# sourceMappingURL=defaultConfig.js.map